import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "float-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Kampanjer", -1)
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_7 = { scope: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_messages = _resolveComponent("messages")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_messages, { ref: "errorHandler" }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-lg btn-outline-secondary mt-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reloadCampaigns()))
      }, [
        _createVNode(_component_fa_icon, { icon: "sync-alt" })
      ])
    ]),
    _hoisted_3,
    _createElementVNode("table", _hoisted_4, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            scope: "col",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sort('id'))),
            class: _normalizeClass(["sortable", {
            sorted: _ctx.sortBy === 'id',
            reverse: _ctx.sortReverse,
          }])
          }, " # ", 2),
          _createElementVNode("th", {
            scope: "col",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort('abbreviation'))),
            class: _normalizeClass(["sortable", {
            sorted: _ctx.sortBy === 'abbreviation',
            reverse: _ctx.sortReverse,
          }])
          }, " Förkortning ", 2),
          _createElementVNode("th", {
            scope: "col",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sort('name'))),
            class: _normalizeClass(["sortable", {
            sorted: _ctx.sortBy === 'name',
            reverse: _ctx.sortReverse,
          }])
          }, " Kampanj ", 2),
          _createElementVNode("th", {
            scope: "col",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort('active'))),
            class: _normalizeClass(["sortable", {
            sorted: _ctx.sortBy === 'active',
            reverse: _ctx.sortReverse,
          }])
          }, " Aktiv ", 2)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.loadingCampaigns)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
              _createElementVNode("td", _hoisted_6, [
                _createVNode(_component_fa_icon, {
                  icon: "spinner",
                  spin: ""
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaigns, (campaign) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: campaign.id
          }, [
            _createElementVNode("th", _hoisted_7, _toDisplayString(campaign.id), 1),
            _createElementVNode("td", null, _toDisplayString(campaign.abbreviation), 1),
            _createElementVNode("td", null, _toDisplayString(campaign.name), 1),
            _createElementVNode("td", null, [
              (campaign.active)
                ? (_openBlock(), _createBlock(_component_fa_icon, {
                    key: 0,
                    icon: "check"
                  }))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}